import { useEffect, useState } from "react";
import { Desktop, DeviceMobile } from "@phosphor-icons/react";
import { toast } from "sonner";

const KEY = "upcast.desktopView";
const DESKTOP_VIEWPORT = "width=1280, initial-scale=0.3, minimum-scale=0.1, maximum-scale=4, user-scalable=yes";
const MOBILE_VIEWPORT = "width=device-width, initial-scale=1";

export const desktopViewOn = () => localStorage.getItem(KEY) === "1";

// Phones / tablets render card layouts (<md); this forces the page to lay out at desktop width so the full tables show (pinch to zoom).
export function applyViewMode() {
  const meta = document.querySelector('meta[name="viewport"]');
  if (meta) meta.setAttribute("content", desktopViewOn() ? DESKTOP_VIEWPORT : MOBILE_VIEWPORT);
}

const isTouchDevice = () => typeof window !== "undefined" && (window.matchMedia?.("(pointer: coarse)")?.matches || navigator.maxTouchPoints > 0);

export function ViewModeToggle() {
  const [on, setOn] = useState(desktopViewOn);
  const [touch] = useState(isTouchDevice);
  useEffect(() => { applyViewMode(); }, [on]);
  if (!touch && !on) return null;
  const flip = () => {
    const next = !on;
    localStorage.setItem(KEY, next ? "1" : "0");
    setOn(next);
    toast.success(next ? "Desktop view on — pinch to zoom, tap again for mobile view" : "Mobile view restored");
  };
  return (
    <button onClick={flip} data-testid="view-mode-toggle" data-mode={on ? "desktop" : "mobile"} title={on ? "Switch to mobile view" : "Show full desktop view"}
      className={`h-8 w-8 flex items-center justify-center rounded-md transition-colors ${on ? "bg-primary/15 text-primary" : "text-foreground hover:bg-muted"}`}>
      {on ? <DeviceMobile size={18} weight="bold" /> : <Desktop size={18} weight="bold" />}
    </button>
  );
}
